import ReducerGenerator from '../../lib/ReducerGenerator'

const generator = new ReducerGenerator('form', '/forms')
const reducer = generator.generate()

export default reducer
